export enum CodeCheckType {
  RUN = 1,
  VERIFY = 2,
}
